export default {
	email(value) {
		const regex = new RegExp(/^[\w-+\.]+@([\w-]+\.)+[\w-]+$/g)

		if (!regex.test(value)) {
			return "Input must be a valid email address."
		} else {
			return null
		}
	},

	maxLength(value, maxLength) {
		if (maxLength) {
			const { range, error } = maxLength
			if (value?.length > range) return error
		} else {
			return null
		}
	},

	maxValue(value, maxValue) {
		if (maxValue) {
			const { range, error } = maxValue
			if (Number(value) > range) return error
		} else {
			return null
		}
	},

	minLength(value, minLength) {
		if (minLength) {
			const { range, error } = minLength
			if (value?.length < range) return error
		} else {
			return null
		}
	},

	minValue(value, minValue) {
		if (minValue) {
			const { range, error } = minValue
			if (Number(value) < range) return error
		} else {
			return null
		}
	},

	phone(value) {
		const regex = new RegExp(/^(\d{10}|\(\d{3}\) \d{3}-\d{4})$/)
		// console.log("value",value)
		if (!regex.test(value)) {
			return "Input must be a valid phone number."
		} else {
			return null
		}
	},

	required(value, error = "") {
		if (!value) return error || "Required."
		else return null
	},

	selected(value, pair = false) {
		const values = Object.values(value || {})

		let selected = values?.some((value) => value)
		if (pair) selected = values?.some((value) => value !== null)

		if (!selected) return "Required."
		else return null
	},

	string(value) {
		const regex = new RegExp(/^[A-Za-z0-9.,\-_():\/&"'# ]*$/)

		if (!regex.test(value)) {
			return 'Invalid character. Input must be alphanumeric or .,-_:/&."'
		} else {
			return null
		}
	}
}
